import React from 'react';
import ReactSelect, { Props } from 'react-select';
import colors from '../../constants/colors.constants';

function SelectV2<Option>({
  isSearchable = false,
  ...rest
}: Omit<Props<Option, false>, 'isMulti'>) {
  return (
    <ReactSelect
      {...rest}
      isSearchable={isSearchable}
      isMulti={false}
      styles={{
        placeholder: (baseStyles) => ({
          ...baseStyles,
          color: colors.subTitle3,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: 40,
          outline: 'none',
          boxShadow: 'none',
          borderRadius: 6,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          borderColor: state.isDisabled
            ? colors.btnDisabledBg
            : state.isFocused
              ? colors.primary3
              : colors.defaultBorder,
          backgroundColor: state.isDisabled ? colors.btnDisabledBg : 'white',
          cursor: 'pointer',
          '&:hover': {
            borderColor: colors.primary3,
          },
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          color: state.isSelected ? 'white' : colors.defaultTypo,
          background: state.isSelected
            ? colors.primary3
            : state.isFocused
              ? colors.greyHover
              : 'white',
          '&:hover': {
            background: state.isSelected ? colors.primary3 : colors.greyHover,
          },
          '&:active': {
            background: colors.greyHover,
          },
          cursor: 'pointer',
        }),
        indicatorSeparator: (baseStyles) => ({
          ...baseStyles,
          width: 0,
        }),
        // clearIndicator: (baseStyles) => ({
        //   ...baseStyles,
        //   padding: 0,
        // }),
        // singleValue: (baseStyles) => ({
        //   ...baseStyles,
        //   color: colors.defaultTypo,
        // }),
        // menu: (baseStyles) => ({
        //   ...baseStyles,
        //   boxShadow: "none",
        //   border: "none",
        //   borderRadius: 6,
        // }),
        // menuList: (baseStyles) => ({
        //   ...baseStyles,
        //   borderRadius: 6,
        //   border: `1px solid ${colors.defaultBorder}`,
        //   boxShadow:
        //     "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        // }),
      }}
    />
  );
}

export default SelectV2;
